<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: true }"
        :loading="loading"
        :expandedRowRender="expandedRowRender"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
          </div>
        </template>
        <template slot="class" slot-scope="school_class">
          <div v-if="school_class">
          <div class="font-weight-bold">{{ school_class.name }}</div>
          </div>
        </template>
        <template slot="subject" slot-scope="subject">
          <div v-if="subject">
            <div class="font-weight-bold">{{subject.name}}</div>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              Edit
            </a>
            <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <edit-lesson-plan ref="editLessonPlan" @edited="handleEdited"/>

  </div>
</template>
<script>
import moment from 'moment'
import EditLessonPlan from '@/components/lessonplan/Forms/Edit/index'
import LessonPlanTopic from '@/components/lessonplan/lessonPlanTopic/index'

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Class',
    dataIndex: 'school_class',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'class' },
  },
  {
    title: 'Subject',
    dataIndex: 'subject',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'subject' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
    width: 300,
  },
]

export default {
  name: 'LessonPlanTable',
  components: {
    EditLessonPlan,
  },
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
    }
  },
  methods: {
    moment,
    // onView(record) {
    //   this.$router.push(`/lessonplan/${record.id}`)
    // },
    expandedRowRender(record) {
      return <LessonPlanTopic lessonPlanId={record.id} />
    },

    showEditModal: function(record) {
      this.$eventBus.$emit('openLessonPlanEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
      // NEW: Emit an event to refresh all LessonPlanTopic instances
      this.$eventBus.$emit('lessonPlanDataUpdated')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure you want to delete this lesson plan?',
        content: 'This action is irreversible.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/lesson-plan/plans/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
<style>
.ant-table-body {
  overflow-x: auto !important;
  overflow-y: hidden !important;
}
</style>
